import { BaseMdkService } from './BaseMdkService';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';
import { MdkTokenRequest } from './service-models/veritrans/MdkTokenRequest';
import { MdkTokenResult } from './service-models/veritrans/MdkTokenResult';

/**
 * サービス基本クラス
 */
export class MdkTokenService extends BaseMdkService {
	// public メソッド  ----------------------------------------------------------

	/**
	 * テスト検索
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public getMdkToken(viewCore: WprBaseViewCore, request: MdkTokenRequest, resMethod: (result: MdkTokenResult) => void): void {
		return this.doPost(viewCore, '/4gtoken', request, resMethod);
	}
	// --------------------------------------------------------------------------
}